export function isPackageSoldOut(item = {}) {
  const value = item.isSoldOut ?? item.IsSoldOut ?? item.soldOut;
  return value === true || value === "true" || value === 1 || value === "1";
}

export function getSeatsLeftLabel(item = {}) {
  const tag = String(item.seatsLeftTag || "").trim();
  if (tag) return tag;

  const count = Number(item.noOfSeatsLeft ?? item.seatsLeftCount ?? item.seatsLeft);
  if (Number.isFinite(count) && count > 0) {
    return `${count} Seat${count === 1 ? "" : "s"} Left`;
  }
  return "";
}

export function getReviewCount(item = {}) {
  const raw =
    item.reviews?.totalReviews ??
    item.totalReviews ??
    item.noOfReviews ??
    item.noOfReview ??
    item.reviewCount;

  if (raw === "" || raw == null) return null;
  const count = Number(raw);
  return Number.isFinite(count) && count > 0 ? count : null;
}

export function getCountdownEndMs(item = {}) {
  if (item.isCountdownShow === false) return 0;

  const raw =
    item.countdownEndDate ||
    item.countDownEndDate ||
    item.countdownDate ||
    item.countDownDate ||
    item.offerEndDate ||
    item.offerExpiryDate ||
    item.timerEndDate ||
    item.countdownExpiryDate ||
    item.countDownExpiryDate ||
    item.countDown?.endDate ||
    item.countdown?.endDate ||
    item.countDown?.expiryDate ||
    item.countdown?.expiryDate;

  if (!raw) return 0;
  const ms = Date.parse(raw);
  return Number.isFinite(ms) && ms > Date.now() ? ms : 0;
}

export function formatCountdown(msLeft) {
  if (msLeft <= 0) return "";

  const totalMinutes = Math.floor(msLeft / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const pad = (value) => String(value).padStart(2, "0");

  return `${pad(hours)}:${pad(minutes)} HRS`;
}
